import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['AnswersReports'] });

const apiAnswersReportsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    listAnswerAbuseReports: builder.query({
      query: ({ ean, questionId, answerId }) => ({
        url: `/community/products/${ean}/questions/${questionId}/answers/${answerId}/abuse/`,
      }),
      providesTags: (result, error, arg) => [{ type: 'AnswersReports', id: arg.answerId }],
    }),
    createAnswerAbuseReport: builder.mutation({
      query: ({ ean, questionId, answerId, payload }) => ({
        url: `/community/products/${ean}/questions/${questionId}/answers/${answerId}/abuse/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'AnswersReports', id: arg.answerId }],
    }),
    retrieveAnswerAbuseReport: builder.query({
      query: ({ ean, questionId, answerId, id }) => ({
        url: `/community/products/${ean}/questions/${questionId}/answers/${answerId}/abuse/${id}`,
      }),
      providesTags: (result, error, arg) => [{ type: 'AnswersReports', id: arg.answerId }],
    }),
    partialUpdateAnswerAbuseReport: builder.mutation({
      query: ({ ean, questionId, answerId, id, note }) => ({
        url: `/community/products/${ean}/questions/${questionId}/answers/${answerId}/abuse/${id}`,
        method: 'PATCH',
        body: { note },
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'AnswersReports', id: arg.answerId }],
    }),
    destroyAnswerAbuseReport: builder.mutation({
      query: ({ ean, questionId, answerId, id }) => ({
        url: `/community/products/${ean}/questions/${questionId}/answers/${answerId}/abuse/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'AnswersReports', id: arg.answerId }],
    }),
  }),
});

export const { useListAnswerAbuseReportsQuery, useCreateAnswerAbuseReportMutation, useRetrieveAnswerAbuseReportQuery, usePartialUpdateAnswerAbuseReportMutation, useDestroyAnswerAbuseReportMutation } = apiAnswersReportsSlice;

export default apiAnswersReportsSlice;
